/**
 * 動画の解像度バリアント（画質選択）API
 *
 * 未生成の画質はサイズが予測値（is_estimated=true）で返る。
 */
import { apiClient } from '@/api/client'

export type VariantStatus = 'ready' | 'none' | 'pending' | 'processing' | 'failed'

export type VideoQualityOption = {
  /** 'original' | '720p' | '480p' */
  quality: string
  label: string
  width: number
  height: number
  /** 予測値または実測値のファイルサイズ（bytes） */
  file_size: number | null
  /** file_size が変換前の予測値かどうか */
  is_estimated: boolean
  status: VariantStatus
  progress: number
  error_message: string | null
}

export type VideoQualitiesResponse = {
  episode_id: number
  options: VideoQualityOption[]
}

export type VariantStatusResponse = {
  episode_id: number
  quality: string
  status: VariantStatus
  progress: number
  file_size: number | null
  error_message: string | null
}

/** エピソードで選択可能な画質一覧を取得する */
export const getEpisodeQualities = async (episodeId: number): Promise<VideoQualitiesResponse> => {
  const res = await apiClient.get<VideoQualitiesResponse>(`/e/${episodeId}/qualities`)
  return res.data
}

/** 指定画質への変換を依頼する（既に生成済み・処理中なら現状を返す） */
export const requestVideoVariant = async (episodeId: number, quality: string): Promise<VariantStatusResponse> => {
  const res = await apiClient.post<VariantStatusResponse>(`/e/${episodeId}/variants/${encodeURIComponent(quality)}`)
  return res.data
}

/** 変換の進捗を取得する（ポーリング用） */
export const getVideoVariantStatus = async (episodeId: number, quality: string): Promise<VariantStatusResponse> => {
  const res = await apiClient.get<VariantStatusResponse>(
    `/e/${episodeId}/variants/${encodeURIComponent(quality)}/status`,
  )
  return res.data
}
